import { render } from "./MagnificPopupModal.vue?vue&type=template&id=94eb6d9a"
import script from "./MagnificPopupModal.vue?vue&type=script&lang=js"
export * from "./MagnificPopupModal.vue?vue&type=script&lang=js"

import "./MagnificPopupModal.vue?vue&type=style&index=0&id=94eb6d9a&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__